module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hjld-dialog-wrap"
  }, [((_vm.cvipMes.cvipstate === 1 || _vm.cvipMes.cvipstate === 10) && _vm.rightUsed[4]) ? _c('CvipDialog', {
    attrs: {
      "title": _vm.title1,
      "btnTxt": _vm.btnTxt1
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("恭喜您，已获得"), _c('span', {
    staticClass: "tit-names"
  }, [_vm._v("黄金亮点")]), _vm._v("特权")]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_c('span', {
    staticClass: "des-in des-use"
  }, [_vm._v("特权介绍：会员可以免费选择任意黄金亮点，使用后将在简历中展现所选择的特长优势。")])]), _vm._v(" "), _c('div', {
    staticClass: "hjld-bg"
  }, [_c('img', {
    staticClass: "hjld-bg-img",
    attrs: {
      "src": require("../../../../assets/imgs/pri-hjld.png")
    }
  })])]) : ((_vm.cvipMes.cvipstate === 1 || _vm.cvipMes.cvipstate === 10) && !_vm.rightUsed[4]) ? _c('CvipDialog', {
    attrs: {
      "title": _vm.title1,
      "btnTxt": _vm.resumeListNum ? '立即体验' : '创建简历'
    },
    on: {
      "btnClick": function($event) {
        return _vm.hightResumefn()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "tit tit-nouse"
  }, [_vm._v("恭喜您，已获得"), _c('span', {
    staticClass: "tit-names"
  }, [_vm._v("黄金亮点")]), _vm._v("特权")]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_c('span', {
    staticClass: "des-in des-use"
  }, [_vm._v("特权介绍：会员可以免费选择任意黄金亮点，使用后将在简历中展现所选择的特长优势。")])]), _vm._v(" "), _c('div', {
    staticClass: "hjld-bg"
  }, [_c('img', {
    staticClass: "hjld-bg-img",
    attrs: {
      "src": require("../../../../assets/imgs/pri-hjld.png")
    }
  })])]) : _c('CvipDialog', {
    attrs: {
      "title": _vm.title,
      "btnTxt": _vm.btnTxt
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "des"
  }, [_vm._v("特权介绍："), _c('span', {
    staticClass: "des-in"
  }, [_vm._v("会员可以免费选择任意黄金亮点，使用后将在简历中展现所选择的特长优势。")])]), _vm._v(" "), _c('div', {
    staticClass: "hjld-bg"
  }, [_c('img', {
    staticClass: "hjld-bg-img",
    attrs: {
      "src": require("../../../../assets/imgs/pri-hjld.png")
    }
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17e3ffc6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/modules/dialog/HjldDialog.vue
// module id = TcG2
// module chunks = 1